export class SavedScreen {
    accessList?: string[];
    configuration?: any;
    description?: string;
    id?: string;
    isLandingPage?: boolean;
    isPublic?: boolean;
    name?: string;
    type?: 'research' | 'dashboard' | 'homescreen' | 'intralinks';
    visible?: boolean;
}
